<template>
    <div>
        <div class="message" style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;">
            <div style="font-size: 12px;" :style="{'color': 'black'}">
                <div style="padding: 5px 8px 6px;" :style="{'background-color': '#F1F0F0'}">
                    <span style="line-height:15.36px;">
                        === สรุปการสั่งซื้อ ===<br><br>

                        Shirt (L): 100 บาท<br>
                        💰ยอดรวม 100 บาท<br>
                        -----------------------------<br>
                        📦ลงทะเบียน +{{setting.normal_charge.contentvalue}} บาท<br>
                        📦EMS +{{setting.ems_charge.contentvalue}} บาท<br>
                        📦KERRY +{{setting.kerry_charge.contentvalue}} บาท<br>
                    </span>
                </div>
            </div>
            <div style="float:left;width: 100%;border: 1px solid #eee; border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;overflow: hidden">
                <ul class="list-group list-group-flush" style="margin-bottom: 0px;" >
                    <li class="list-group-item" style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px" >
                        <span style="color: #0084FF">สั่งเพิ่ม/แก้ไข</span>
                    </li>
                    <li class="list-group-item" style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px;border-top:1px solid #eee;" >
                        <span style="color: #0084FF">โอนเงิน</span>
                    </li>
                    
                </ul>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
    export default {
        computed: {
            ...mapGetters({
                setting: "setting"
            }),
        }
        
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/ViewCartSummaryViewer.vue